
        module.exports = __webpack_public_path__ + "assets/images/logo-2050.0284b20c.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 400,
            height: 120,
            type: "png",
            bytes: 23949,

            toString: function() {
                return src;
            }
        };
    